import { Box, Text } from "@chakra-ui/layout";
import { Flex } from "@chakra-ui/react";
import { nanoid } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getEstateDue } from "../../pages/Manager-Portal/EstateDue/services/estateDueApis";
import { LogOutSvg } from "../../svgs/LogOutSvg";
import { LinkTo } from "../Nav/LinkTo";
import {
  MANAGER_NAV_ITEMS,
  SECURITY_PORTAL_NAV_ITEMS,
} from "./sidebar.constants";
import "./sidebar.css";

export const SideBar = ({ toggle, type = "manager" }) => {
  const userId = useSelector((state) => state.auth.user);
  const [estateInfo, setEstateInfo] = useState([]);

  useEffect(() => {
    getEstateDue(setEstateInfo, userId);
  }, [userId]);

  console.log(estateInfo, "infooo", userId)

  return (
    <Box className="sidebar">
      <Box className="sidebar-inner">
        {/* Brand - fixed at top */}
        <Box>
          <Text
            lineHeight={1.4}
            p="10px"
            mt={["0", "1.5"]}
            fontSize={[".9em", "25px"]}
            fontWeight={"900"}
            mb="30px"
          >
            {estateInfo?.estateName}
          </Text>
        </Box>

        {/* Scrollable content area including logout */}
        <Box 
          flex={1} 
          overflowY="auto" 
          css={{
            '&::-webkit-scrollbar': { 
              width: '8px' 
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '4px'
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '4px'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: 'rgba(255, 255, 255, 0.5)'
            },
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1)',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          <Flex flexDirection="column" gap="0px" minHeight="100%">
            {/* MANAGER LINKS */}
            {type === "manager" &&
              MANAGER_NAV_ITEMS?.map(({ title, to, icon }) => (
                <LinkTo
                  key={nanoid()}
                  to={to}
                  title={title}
                  toggle={toggle}
                  id={1}
                  iconComponent={icon}
                />
              ))}

            {/* SECURITY LINKS */}
            {type === "security" &&
              SECURITY_PORTAL_NAV_ITEMS?.map(({ title, to, icon }) => (
                <LinkTo
                  key={nanoid()}
                  to={to}
                  title={title}
                  toggle={toggle}
                  id={1}
                  iconComponent={icon}
                />
              ))}

            {/* Spacer to push logout to bottom when content is short */}
            <Box flex={1} />

            {/* Logout - scrolls with content */}
            <Box size="md" color="#fff" fontSize=".9em" py="10px" pb="1.5rem">
              <LinkTo
                logout
                type={type}
                to="/log_out"
                title="Logout"
                id={2}
                iconComponent={LogOutSvg}
              />
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};